// Libraries
import {createGlobalStyle} from 'styled-components';

const PrintPageStyle = createGlobalStyle`
  /* stylelint-disable property-no-vendor-prefix */
  /* stylelint-disable unit-allowed-list */

  @media print {
    body, div, h1, h2, h3, ol, ul {
      border: 0;
      float: none !important;
      position: static !important;
      overflow: visible !important;
    }

    div, img {
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    [data-no-print] {
      display: none !important;
    }

    [data-print-background] {
      width: 100%;
      background-color: white !important;
    }

    [data-print-wrapper] {
      width: 100% !important;
      padding: 0 !important;
    }

    [data-print-container] {
      width: 100% !important;
    }

    [data-print] {
      overflow: visible !important;
    }

    [data-avoid-page-break] {
      page-break-inside: avoid !important;
    }

    /* Make sure all text elements within columns can break across pages */
    .document-text-item,
    .document-text-item p,
    .document-text-item div,
    .document-text-item span {
      break-inside: auto !important;
      page-break-inside: auto !important;
    }

    /* Override inline-block spans generated by the rich-text editor –
       inline-block prevents browsers from breaking long text across pages
       which is what caused the overlapping we were seeing. 
       Only apply this within column layouts to preserve font styling elsewhere. */
    .columns-row span[style*="inline-block"] {
      display: inline !important;
    }

    /* Also override the document-text-item spans that have inline-block in CSS
       but only within column layouts */
    .columns-row .document-text-item span {
      display: inline !important;
    }

    /* Use CSS table layout to maintain side-by-side columns */
    .columns-row {
      display: table !important;
      width: 100% !important;
      table-layout: fixed !important;
      border-collapse: separate !important;
      border-spacing: 8px 0 !important;

      /* Avoid splitting a two-column block between pages – if it cannot fit
         in the remaining space the whole block is moved to the next sheet,
         preventing the overlap we saw in edge cases. */
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }

    /* Make columns table cells */
    .columns-row .column {
      display: table-cell !important;
      float: none !important;
      width: 50% !important;
      vertical-align: top !important;
      break-inside: auto !important;
      page-break-inside: auto !important;
    }

    /* Hide the spacer elements */
    .columns-row .column-spacer {
      display: none !important;
    }

    /* Ensure wrapper elements don't prevent page breaks */
    [class*="document-text"],
    [class*="Document"] {
      break-inside: auto !important;
      page-break-inside: auto !important;
    }
  }
`;

export default PrintPageStyle;
